import React, { FunctionComponent, ReactNode } from 'react'
import { useSelector } from 'react-redux'

import { DynamicModuleLoader } from 'redux-dynamic-modules'

import { getFeaturesModule } from '../module'
import { selectAreFlagsLoaded } from '../Store/selectors'

type Props = {
  fallback: ReactNode
}

const FeatureGate: FunctionComponent<Props> = ({ children, fallback }) => {
  const flagsAreLoaded = useSelector(selectAreFlagsLoaded)
  if (!flagsAreLoaded) {
    return <>{fallback}</>
  }
  return <>{children}</>
}

const WrappedFeatureGate: FunctionComponent<Props> = ({ children, fallback }) => (
  <DynamicModuleLoader modules={[getFeaturesModule()]}>
    <FeatureGate fallback={fallback}>{children}</FeatureGate>
  </DynamicModuleLoader>
)

export { WrappedFeatureGate as FeatureGate }
